import styled from 'styled-components';
import TransferField from '../../../../../components/fields/TransferField';

const StyledTransferField = styled(TransferField)`
    & .ant-transfer-list {
        flex: 1;
    }
`;

export default StyledTransferField;
